module.exports = __webpack_public_path__ + "static/media/cq_dopo_il_finanziamento.b9859caa.svg";